import { PageLayout } from '@/components/layout'
import { Footer } from '@/components/layout/Footer'
import { useSEO } from '@/hooks/useSEO'

export const ContactUs = () => {
  useSEO({
    title: 'Contact Us - Binder Tech Solutions',
    description: 'Get in touch with Binder Tech Solutions. Contact us via email, phone, or visit our office in Jeddah, Saudi Arabia.',
    keywords: 'contact, support, Binder Tech Solutions, Jeddah, Saudi Arabia',
    url: 'https://bindertech.com/contact-us',
    type: 'website',
  })

  return (
    <PageLayout>
      <div className="mx-auto max-w-4xl px-4 py-12 md:px-10 lg:px-20">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-text-main-light dark:text-text-main-dark mb-4">
            Contact Us
          </h1>
          <p className="text-text-sub-light dark:text-text-sub-dark text-lg">
            We're here to help! Get in touch with us through any of the following methods.
          </p>
        </div>

        
          {/* Contact Information Card */}
          <div className="rounded-xl bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark p-6 shadow-sm">
            <h2 className="text-2xl font-semibold mb-6 text-text-main-light dark:text-text-main-dark">
              Contact Information
            </h2>
            
            <div className="space-y-6">
              {/* Email */}
              <div className="flex items-start gap-4">
                <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary">
                  <span className="material-symbols-outlined">email</span>
                </div>
                <div>
                  <h3 className="font-semibold text-text-main-light dark:text-text-main-dark mb-1">
                    Email
                  </h3>
                  <a
                    href="mailto:contact-us@binder.com"
                    className="text-primary hover:underline text-text-sub-light dark:text-text-sub-dark"
                  >
                    contact-us@binder.com
                  </a>
                </div>
              </div>

              {/* Phone */}
              <div className="flex items-start gap-4">
                <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary">
                  <span className="material-symbols-outlined">phone</span>
                </div>
                <div>
                  <h3 className="font-semibold text-text-main-light dark:text-text-main-dark mb-1">
                    Phone
                  </h3>
                  <a
                    href="tel:+966556559640"
                    className="text-primary hover:underline text-text-sub-light dark:text-text-sub-dark"
                  >
                    (+966) 55 655 9640
                  </a>
                </div>
              </div>

              {/* Address */}
              <div className="flex items-start gap-4">
                <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary">
                  <span className="material-symbols-outlined">location_on</span>
                </div>
                <div>
                  <h3 className="font-semibold text-text-main-light dark:text-text-main-dark mb-1">
                    Address
                  </h3>
                  <a
                    href="https://maps.app.goo.gl/m5JxScuk2r8geJXj6"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary hover:underline text-text-sub-light dark:text-text-sub-dark"
                  >
                    3697 طريق الكورنيش، حي المرجان، جدة 23712 7849،
                  </a>
                </div>
              </div>

              {/* Office Hours */}
              <div className="flex items-start gap-4">
                <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary">
                  <span className="material-symbols-outlined">schedule</span>
                </div>
                <div>
                  <h3 className="font-semibold text-text-main-light dark:text-text-main-dark mb-1">
                    Office Hours
                  </h3>
                  <p className="text-text-sub-light dark:text-text-sub-dark">
                    Sunday - Thursday<br />
                    9:00 AM - 6:00 PM
                  </p>
                </div>
              </div>
            </div>
          </div>
      </div>
      <Footer />
    </PageLayout>
  )
}

